'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of calendar
 */ const Calendar = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 105 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52.6914",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M24.7188 36.6445H77.7028V70.4362C77.7028 74.6436 74.292 78.0544 70.0846 78.0544H26.7503C25.6283 78.0544 24.7188 77.1448 24.7188 76.0229V36.6445Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M24.7188 30.1907C24.7188 29.0687 25.6283 28.1592 26.7503 28.1592H75.6713C76.7932 28.1592 77.7028 29.0687 77.7028 30.1907V36.6469H24.7188V30.1907Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M35.9033 41.6152H28.5781V48.9404H35.9033V41.6152Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M48.7744 41.6152H41.4492V48.9404H48.7744V41.6152Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M61.6572 41.6152H54.332V48.9404H61.6572V41.6152Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M74.5439 41.6152H67.2188V48.9404H74.5439V41.6152Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M35.9033 54.2227H28.5781V61.5478H35.9033V54.2227Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M48.7783 54.2227H41.4531V61.5478H48.7783V54.2227Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M35.9033 66.8428H28.5781V74.1679H35.9033V66.8428Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M48.7783 66.8428H41.4531V74.1679H48.7783V66.8428Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M33.1474 32.1809C32.0646 32.1809 31.1875 31.3038 31.1875 30.221V25.4267C31.1875 24.3439 32.0646 23.4668 33.1474 23.4668C34.2302 23.4668 35.1073 24.3439 35.1073 25.4267V30.2184C35.1073 31.3012 34.2302 32.1783 33.1474 32.1783V32.1809Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M45.4599 32.1809C44.3771 32.1809 43.5 31.3038 43.5 30.221V25.4267C43.5 24.3439 44.3771 23.4668 45.4599 23.4668C46.5427 23.4668 47.4198 24.3439 47.4198 25.4267V30.2184C47.4198 31.3012 46.5427 32.1783 45.4599 32.1783V32.1809Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M59.7362 25.4267C59.7362 24.3443 58.8587 23.4668 57.7763 23.4668C56.6939 23.4668 55.8164 24.3443 55.8164 25.4267V30.221C55.8164 31.3034 56.6939 32.1809 57.7763 32.1809C58.8587 32.1809 59.7362 31.3034 59.7362 30.221V25.4267Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M70.0849 32.1809C69.0021 32.1809 68.125 31.3038 68.125 30.221V25.4267C68.125 24.3439 69.0021 23.4668 70.0849 23.4668C71.1677 23.4668 72.0448 24.3439 72.0448 25.4267V30.2184C72.0448 31.3012 71.1677 32.1783 70.0849 32.1783V32.1809Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M67.2246 52.1445C59.4383 52.1445 53.1016 58.4812 53.1016 66.2675C53.1016 74.0538 59.4383 80.3906 67.2246 80.3906C75.0109 80.3906 81.3476 74.0538 81.3476 66.2675C81.3476 58.4812 75.0109 52.1445 67.2246 52.1445Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M60.4577 68.3602C59.8474 67.7633 59.8474 66.7956 60.4577 66.1978C61.0679 65.6009 62.0581 65.6009 62.6684 66.1978L65.4793 68.9464L72.24 61.3001C72.7859 60.6499 73.7679 60.5568 74.4317 61.0907C75.0963 61.6247 75.1915 62.5852 74.6457 63.2345L66.8766 72.0809C66.8231 72.1563 66.7623 72.229 66.6934 72.2965C66.0832 72.8934 65.093 72.8934 64.4828 72.2965L60.4577 68.3602Z",
                fill: theme.ds5.asset[assetColor]["100"]
            })
        ]
    });
};

exports.Calendar = Calendar;
//# sourceMappingURL=Calendar.cjs.map
